import { Box, Flex, useDisclosure, Text } from '@chakra-ui/react';
import { Link } from '@tanstack/react-router';
import { useState, type FC } from 'react';

import { CardContent } from '$/components/common/Card/CardContent';
import { Show } from '$/components/common/Flow/Show';
import { ProjectCardContextMenu } from '$/components/core/Projects/ProjectCard/components/ProjectCardContextMenu';
import { type ProjectOverviewItem } from '$/services/usecases/projects/mapper/projectOverview';

interface Props {
  project: ProjectOverviewItem;
  disableContextMenu?: boolean;
}

export const ProjectCard: FC<Props> = ({
  project,
  disableContextMenu = false,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [isHovered, setIsHovered] = useState(false);
  const [imageHash] = useState(() => Date.now());

  const getRoute = () => {
    if (project.type === 'editor') {
      return `/editor?projectId=${project.id}`;
    }
    if (project.type === 'legacy-inspiration') {
      return '/inspirations/legacy/$id';
    }
    return '/inspiration-project/$id';
  };

  return (
    <Link to={getRoute()} params={{ id: project.id }}>
      <Box
        pos='relative'
        overflow='hidden'
        onContextMenu={(event) => {
          if (disableContextMenu) {
            return;
          }
          event.preventDefault();
          onOpen();
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Show when={!disableContextMenu && (isHovered || isOpen)}>
          <ProjectCardContextMenu
            isOpen={isOpen}
            onClose={onClose}
            onOpen={onOpen}
            project={project}
          />
        </Show>
        {project.schoolClassId != null && (
          <Flex
            pos='absolute'
            top='7%'
            left='-40%'
            justify='center'
            w='100%'
            bg='primaryButton.background'
            transform='rotate(-45deg)'
            userSelect='none'
          >
            <Text color='reverseText' fontSize='xs' fontWeight='bold'>
              SCHOOL
            </Text>
          </Flex>
        )}
        <CardContent
          label={project.name}
          bg='transparent'
          image={`${project.thumbnailUrl}?${imageHash}`}
        />
      </Box>
    </Link>
  );
};
